import { Controller } from "@hotwired/stimulus"

const SEPARATOR_RUN = /[^\S\n]*[,;\n][\s,;]*/g

const oneLineBreak = (run) => `${run.match(/[,;]/)?.[0] ?? ""}\n`

export default class extends Controller {
  static values = {
    minRows: { type: Number, default: 1 },
    maxRows: { type: Number, default: 12 },
  }

  connect() {
    this.resize()
  }

  resize(event) {
    if (!event?.inputType?.startsWith("delete")) this.oneEntryPerLine()

    this.element.rows = Math.min(
      this.maxRowsValue,
      Math.max(this.minRowsValue, this.element.value.split("\n").length),
    )
    this.growPastWrappedLines()

    const capped = this.element.rows >= this.maxRowsValue
    this.element.classList.toggle("overflow-hidden", !capped)
    this.element.classList.toggle("overflow-auto", capped)
  }

  growPastWrappedLines() {
    while (this.element.rows < this.maxRowsValue && this.element.scrollHeight > this.element.clientHeight) {
      this.element.rows += 1
    }
  }

  oneEntryPerLine() {
    const el = this.element
    const value = el.value.replace(SEPARATOR_RUN, oneLineBreak)
    if (value === el.value) return

    const caret = el.value.slice(0, el.selectionStart).replace(SEPARATOR_RUN, oneLineBreak).length
    const focused = document.activeElement === el
    el.value = value
    if (focused) el.setSelectionRange(caret, caret)
  }
}
